export const usersQueryKeys = {
  all: ['users'] as const,
  list: () => [...usersQueryKeys.all, 'list'] as const,
  detail: (userId: string | undefined) =>
    [...usersQueryKeys.all, 'detail', userId] as const,
  current: () => [...usersQueryKeys.all, 'current'] as const,
  workspace: () => [...usersQueryKeys.all, 'workspace'] as const,
};
